module.exports = __webpack_public_path__ + "media/images/links_to_banks_on_success_page/Vietinbank-a18d7c5ed168ab185fb5da0469b7f939.png";